import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.lpsysadmin.widget.notion.editor');
import { OnInit, Input, Output, EventEmitter, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';
import { ElementRef, ViewChild, ChangeDetectorRef } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { createNotionEditor, SLASH_MENU_ITEMS, SlashMenuItem, TEXT_COLORS, BG_COLORS, TURN_INTO_ITEMS, TurnIntoItem } from "src/libs/portal/lpsysadmin/tiptap";
import { Editor } from '@tiptap/core';

@Component({
    selector: 'wiz-portal-lpsysadmin-widget-notion-editor',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/build/src/app/portal.lpsysadmin.widget.notion.editor/view.scss */
@charset "UTF-8";
:host {
  display: block;
  width: 100%;
  height: 100%;
}

.notion-editor-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
}

/* ─── Icon Shared Styles ─── */
.toolbar-icon-text {
  font-size: 13px;
  line-height: 1;
  font-family: "Georgia", "Times New Roman", serif;
}

.toolbar-icon-code {
  font-family: "JetBrains Mono", "Fira Code", monospace !important;
  font-size: 10px !important;
  letter-spacing: -0.5px;
}

.toolbar-icon-svg {
  width: 14px;
  height: 14px;
  flex-shrink: 0;
}

.toolbar-dropdown-icon-svg {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  color: #6b7280;
}

/* ─── Fixed Toolbar ─── */
.editor-fixed-toolbar {
  display: flex;
  align-items: center;
  gap: 2px;
  padding: 4px 8px;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  margin-bottom: 4px;
  flex-wrap: wrap;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
  position: sticky;
  top: 0;
  z-index: 45;
}
.editor-fixed-toolbar .toolbar-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 28px;
  height: 28px;
  border: none;
  background: none;
  border-radius: 4px;
  cursor: pointer;
  color: #4b5563;
  font-size: 12px;
  transition: background 0.1s, color 0.1s;
  padding: 0 4px;
  position: relative;
}
.editor-fixed-toolbar .toolbar-btn:hover {
  background: #f3f4f6;
  color: #1f2937;
}
.editor-fixed-toolbar .toolbar-btn.is-active {
  background: #eff6ff;
  color: #2563eb;
}
.editor-fixed-toolbar .toolbar-btn .toolbar-color-indicator {
  position: absolute;
  bottom: 2px;
  left: 50%;
  transform: translateX(-50%);
  width: 14px;
  height: 3px;
  border-radius: 1px;
}
.editor-fixed-toolbar .toolbar-btn-text {
  display: flex;
  align-items: center;
  gap: 2px;
  padding: 0 8px;
  white-space: nowrap;
  font-size: 12px;
  font-weight: 500;
}
.editor-fixed-toolbar .toolbar-sep {
  display: block;
  width: 1px;
  height: 18px;
  background: #e5e7eb;
  margin: 0 3px;
  flex-shrink: 0;
}
.editor-fixed-toolbar .toolbar-dropdown-wrap {
  position: relative;
}
.editor-fixed-toolbar .toolbar-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  margin-top: 4px;
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  padding: 6px;
  z-index: 60;
  min-width: 160px;
}
.editor-fixed-toolbar .toolbar-dropdown .toolbar-dropdown-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 10px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 13px;
  transition: background 0.1s;
}
.editor-fixed-toolbar .toolbar-dropdown .toolbar-dropdown-item:hover {
  background: #f3f4f6;
}
.editor-fixed-toolbar .toolbar-dropdown .toolbar-dropdown-label {
  font-size: 11px;
  font-weight: 600;
  color: #9ca3af;
  padding: 4px 10px 6px;
}
.editor-fixed-toolbar .toolbar-insert-dropdown {
  min-width: 180px;
}
.editor-fixed-toolbar .table-grid-dropdown {
  min-width: 210px;
  padding: 12px;
}
.editor-fixed-toolbar .table-grid-dropdown .table-grid-label {
  font-size: 12px;
  font-weight: 500;
  color: #6b7280;
  text-align: center;
  margin-bottom: 8px;
}
.editor-fixed-toolbar .table-grid-dropdown .table-grid {
  display: flex;
  flex-direction: column;
  gap: 3px;
  align-items: center;
}
.editor-fixed-toolbar .table-grid-dropdown .table-grid-row {
  display: flex;
  gap: 3px;
}
.editor-fixed-toolbar .table-grid-dropdown .table-grid-cell {
  width: 28px;
  height: 28px;
  border: 1.5px solid #d1d5db;
  border-radius: 3px;
  cursor: pointer;
  background: #fff;
  transition: background 0.05s, border-color 0.05s;
}
.editor-fixed-toolbar .table-grid-dropdown .table-grid-cell.active {
  background: #dbeafe;
  border-color: #60a5fa;
}
.editor-fixed-toolbar .table-grid-dropdown .table-grid-cell:hover {
  border-color: #93c5fd;
}
.editor-fixed-toolbar .toolbar-color-dropdown {
  min-width: 220px;
  padding: 10px;
}
.editor-fixed-toolbar .toolbar-color-dropdown .toolbar-color-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}
.editor-fixed-toolbar .toolbar-color-dropdown .color-swatch {
  width: 24px;
  height: 24px;
  border-radius: 4px;
  border: 1px solid #e5e7eb;
  cursor: pointer;
  transition: transform 0.1s, box-shadow 0.1s;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}
.editor-fixed-toolbar .toolbar-color-dropdown .color-swatch:hover {
  transform: scale(1.2);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
  z-index: 1;
}
.editor-fixed-toolbar .toolbar-color-dropdown .color-swatch-reset {
  background: #fff !important;
  color: #9ca3af;
  font-size: 12px;
}

/* ─── Editor Core ─── */
.notion-editor {
  width: 100%;
  height: 100%;
  padding-left: 48px;
}
.notion-editor .tiptap {
  width: 100%;
  height: 100%;
  outline: none;
  padding: 8px 4px;
  font-size: 15px;
  line-height: 1.7;
  color: #1e1e1e;
  /* ─── Clean Notion-style blocks (no cell borders) ─── */
  /* Callout / details — keep their own styling */
  /* Placeholder — all empty nodes */
  /* Headings */
  /* First heading — no top margin */
  /* Paragraphs */
  /* Lists */
  /* Nested lists */
  /* Top-level list margin reset */
  /* Task list */
  /* Blockquote */
  /* Code block */
  /* Inline code */
  /* Horizontal rule */
  /* Link */
  /* Image */
  /* ─── Table ─── */
  /* ─── Callout ─── */
  /* ─── Toggle ─── */
  /* ─── Column Layout ─── */
  /* ─── File Attachment ─── */
  /* ─── Text alignment ─── */
  /* ─── Highlight / Colors ─── */
  /* ─── Selection styling ─── */
  /* Gapcursor */
  /* syntax highlight (lowlight) */
}
.notion-editor .tiptap > * + * {
  margin-top: 2px;
}
.notion-editor .tiptap > * {
  position: relative;
  padding: 3px 4px;
  margin-left: 0;
  margin-right: 0;
  border-radius: 4px;
  transition: background 0.1s ease;
}
.notion-editor .tiptap > *:hover {
  background: rgba(55, 53, 47, 0.03);
}
.notion-editor .tiptap > .callout,
.notion-editor .tiptap > details {
  border: 1px solid #e5e7eb;
}
.notion-editor .tiptap > .callout:hover,
.notion-editor .tiptap > details:hover {
  border-color: #d1d5db;
  background: transparent;
}
.notion-editor .tiptap .is-empty::before {
  content: attr(data-placeholder);
  float: left;
  color: #adb5bd;
  pointer-events: none;
  height: 0;
  font-size: 14px;
}
.notion-editor .tiptap h1 {
  font-size: 1.875em;
  font-weight: 700;
  margin-top: 1.2em;
  margin-bottom: 0.3em;
  line-height: 1.3;
}
.notion-editor .tiptap h2 {
  font-size: 1.5em;
  font-weight: 700;
  margin-top: 1em;
  margin-bottom: 0.25em;
  line-height: 1.35;
}
.notion-editor .tiptap h3 {
  font-size: 1.25em;
  font-weight: 600;
  margin-top: 0.8em;
  margin-bottom: 0.2em;
  line-height: 1.4;
}
.notion-editor .tiptap h1.is-empty::before {
  font-size: 1.875em;
  font-weight: 700;
}
.notion-editor .tiptap h2.is-empty::before {
  font-size: 1.5em;
  font-weight: 700;
}
.notion-editor .tiptap h3.is-empty::before {
  font-size: 1.25em;
  font-weight: 600;
}
.notion-editor .tiptap > h1:first-child {
  margin-top: 0;
}
.notion-editor .tiptap > h2:first-child {
  margin-top: 0;
}
.notion-editor .tiptap > h3:first-child {
  margin-top: 0;
}
.notion-editor .tiptap p {
  margin: 0;
  min-height: 1em;
}
.notion-editor .tiptap ul, .notion-editor .tiptap ol {
  padding-left: 1.5em;
  margin: 0.3em 0;
}
.notion-editor .tiptap ul {
  list-style-type: disc;
}
.notion-editor .tiptap ol {
  list-style-type: decimal;
}
.notion-editor .tiptap li {
  margin: 2px 0;
}
.notion-editor .tiptap li p {
  margin: 0;
}
.notion-editor .tiptap li > ul, .notion-editor .tiptap li > ol {
  margin: 0;
}
.notion-editor .tiptap > ul, .notion-editor .tiptap > ol {
  margin: 0;
}
.notion-editor .tiptap ul[data-type=taskList] {
  list-style: none;
  padding-left: 0;
}
.notion-editor .tiptap ul[data-type=taskList] li {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}
.notion-editor .tiptap ul[data-type=taskList] li label {
  flex-shrink: 0;
  margin-top: 3px;
}
.notion-editor .tiptap ul[data-type=taskList] li label input[type=checkbox] {
  width: 16px;
  height: 16px;
  accent-color: #2563eb;
  cursor: pointer;
}
.notion-editor .tiptap ul[data-type=taskList] li > div {
  flex: 1;
}
.notion-editor .tiptap ul[data-type=taskList] li[data-checked=true] > div p {
  text-decoration: line-through;
  color: #9ca3af;
}
.notion-editor .tiptap blockquote {
  border-left: 3px solid #d1d5db;
  padding: 4px 16px;
  margin: 8px 0;
  color: #6b7280;
  background: #f9fafb;
  border-radius: 0 4px 4px 0;
}
.notion-editor .tiptap > blockquote {
  margin: 4px 0;
}
.notion-editor .tiptap pre {
  background: #1e1e2e;
  color: #cdd6f4;
  border-radius: 8px;
  padding: 16px;
  margin: 8px 0;
  overflow-x: auto;
  font-family: "JetBrains Mono", "Fira Code", monospace;
  font-size: 13px;
  line-height: 1.6;
}
.notion-editor .tiptap pre code {
  background: none;
  color: inherit;
  padding: 0;
  font-size: inherit;
}
.notion-editor .tiptap > pre {
  margin: 4px 0;
}
.notion-editor .tiptap code {
  background: #f1f3f5;
  color: #e03131;
  padding: 2px 6px;
  border-radius: 4px;
  font-family: "JetBrains Mono", "Fira Code", monospace;
  font-size: 0.9em;
}
.notion-editor .tiptap hr {
  border: none;
  border-top: 2px solid #e5e7eb;
  margin: 16px 0;
}
.notion-editor .tiptap hr.ProseMirror-selectednode {
  border-top-color: #2563eb;
}
.notion-editor .tiptap > hr {
  margin: 8px 0;
  padding: 4px 0;
}
.notion-editor .tiptap a {
  color: #2563eb;
  text-decoration: underline;
  text-underline-offset: 2px;
  cursor: pointer;
}
.notion-editor .tiptap a:hover {
  color: #1d4ed8;
}
.notion-editor .tiptap img {
  max-width: 100%;
  height: auto;
  border-radius: 6px;
  margin: 8px 0;
  cursor: default;
  transition: box-shadow 0.15s;
}
.notion-editor .tiptap img.ProseMirror-selectednode {
  outline: 2px solid #2563eb;
  outline-offset: 2px;
}
.notion-editor .tiptap img:hover {
  box-shadow: 0 0 0 1px rgba(37, 99, 235, 0.2);
}
.notion-editor .tiptap .tableWrapper {
  width: 100%;
  margin: 12px 0;
  overflow-x: auto;
}
.notion-editor .tiptap table {
  border-collapse: collapse;
  width: 100%;
  table-layout: fixed;
  overflow: visible;
}
.notion-editor .tiptap table td, .notion-editor .tiptap table th {
  border: 1px solid #d1d5db;
  padding: 8px 12px;
  vertical-align: top;
  min-width: 80px;
  position: relative;
}
.notion-editor .tiptap table td > *, .notion-editor .tiptap table th > * {
  margin: 0;
}
.notion-editor .tiptap table td p, .notion-editor .tiptap table th p {
  min-height: 1em;
}
.notion-editor .tiptap table th {
  background: #f3f4f6;
  font-weight: 600;
}
.notion-editor .tiptap table .selectedCell {
  background: #dbeafe !important;
}
.notion-editor .tiptap table .column-resize-handle {
  position: absolute;
  right: -2px;
  top: 0;
  bottom: 0;
  width: 4px;
  background: #2563eb;
  cursor: col-resize;
  z-index: 20;
}
.notion-editor .tiptap.resize-cursor {
  cursor: col-resize;
}
.notion-editor .tiptap .callout {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 16px;
  border-radius: 8px;
  margin: 8px 0;
  border: 1px solid;
}
.notion-editor .tiptap .callout-icon {
  flex-shrink: 0;
  font-size: 20px;
  line-height: 1.4;
}
.notion-editor .tiptap .callout-content {
  flex: 1;
  min-width: 0;
}
.notion-editor .tiptap .callout-content p {
  margin: 0;
}
.notion-editor .tiptap .callout[data-type=info], .notion-editor .tiptap .callout[data-callout-type=info] {
  background: #eff6ff;
  border-color: #bfdbfe;
}
.notion-editor .tiptap .callout[data-type=info] .callout-icon::before, .notion-editor .tiptap .callout[data-callout-type=info] .callout-icon::before {
  content: "ℹ️";
}
.notion-editor .tiptap .callout[data-type=warning], .notion-editor .tiptap .callout[data-callout-type=warning] {
  background: #fffbeb;
  border-color: #fde68a;
}
.notion-editor .tiptap .callout[data-type=warning] .callout-icon::before, .notion-editor .tiptap .callout[data-callout-type=warning] .callout-icon::before {
  content: "⚠️";
}
.notion-editor .tiptap .callout[data-type=error], .notion-editor .tiptap .callout[data-callout-type=error] {
  background: #fef2f2;
  border-color: #fecaca;
}
.notion-editor .tiptap .callout[data-type=error] .callout-icon::before, .notion-editor .tiptap .callout[data-callout-type=error] .callout-icon::before {
  content: "🚨";
}
.notion-editor .tiptap .callout[data-type=success], .notion-editor .tiptap .callout[data-callout-type=success] {
  background: #f0fdf4;
  border-color: #bbf7d0;
}
.notion-editor .tiptap .callout[data-type=success] .callout-icon::before, .notion-editor .tiptap .callout[data-callout-type=success] .callout-icon::before {
  content: "✅";
}
.notion-editor .tiptap .callout[data-type=default], .notion-editor .tiptap .callout:not([data-type]):not([data-callout-type]) {
  background: #f9fafb;
  border-color: #e5e7eb;
}
.notion-editor .tiptap .callout[data-type=default] .callout-icon::before, .notion-editor .tiptap .callout:not([data-type]):not([data-callout-type]) .callout-icon::before {
  content: "💡";
}
.notion-editor .tiptap > .callout {
  margin: 4px 0;
}
.notion-editor .tiptap details {
  margin: 6px 0;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  overflow: hidden;
}
.notion-editor .tiptap details summary {
  padding: 10px 14px;
  cursor: pointer;
  font-weight: 500;
  background: #f9fafb;
  user-select: none;
}
.notion-editor .tiptap details summary:hover {
  background: #f3f4f6;
}
.notion-editor .tiptap details summary::marker {
  color: #9ca3af;
}
.notion-editor .tiptap details > div {
  padding: 10px 14px;
}
.notion-editor .tiptap > details {
  margin: 4px 0;
}
.notion-editor .tiptap .column-block {
  display: flex;
  gap: 16px;
  margin: 8px 0;
}
.notion-editor .tiptap .column-block .column {
  flex: 1;
  min-width: 0;
  padding: 4px 8px;
  border: 1px dashed transparent;
  border-radius: 4px;
  transition: border-color 0.15s;
}
.notion-editor .tiptap .column-block .column:hover {
  border-color: #d1d5db;
}
.notion-editor .tiptap > .column-block {
  margin: 4px 0;
}
.notion-editor .tiptap .file-attachment {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 14px;
  background: #f3f4f6;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  margin: 4px 0;
  font-size: 13px;
  cursor: pointer;
  color: #374151;
  text-decoration: none;
}
.notion-editor .tiptap .file-attachment:hover {
  background: #e5e7eb;
}
.notion-editor .tiptap .file-attachment .file-icon {
  font-size: 16px;
}
.notion-editor .tiptap .file-attachment .file-name {
  font-weight: 500;
}
.notion-editor .tiptap .file-attachment .file-size {
  color: #9ca3af;
  font-size: 11px;
}
.notion-editor .tiptap .text-left {
  text-align: left;
}
.notion-editor .tiptap .text-center {
  text-align: center;
}
.notion-editor .tiptap .text-right {
  text-align: right;
}
.notion-editor .tiptap .text-justify {
  text-align: justify;
}
.notion-editor .tiptap mark {
  border-radius: 2px;
  padding: 1px 2px;
}
.notion-editor .tiptap .ProseMirror-selectednode {
  outline: 2px solid #2563eb;
  outline-offset: 2px;
}
.notion-editor .tiptap .ProseMirror-gapcursor::after {
  border-top: 1px solid #1e1e1e;
}
.notion-editor .tiptap .hljs-comment, .notion-editor .tiptap .hljs-quote {
  color: #6c7086;
}
.notion-editor .tiptap .hljs-variable, .notion-editor .tiptap .hljs-template-variable, .notion-editor .tiptap .hljs-attribute,
.notion-editor .tiptap .hljs-tag, .notion-editor .tiptap .hljs-regexp, .notion-editor .tiptap .hljs-link {
  color: #f38ba8;
}
.notion-editor .tiptap .hljs-number, .notion-editor .tiptap .hljs-meta, .notion-editor .tiptap .hljs-built_in,
.notion-editor .tiptap .hljs-builtin-name, .notion-editor .tiptap .hljs-literal, .notion-editor .tiptap .hljs-type, .notion-editor .tiptap .hljs-params {
  color: #fab387;
}
.notion-editor .tiptap .hljs-string, .notion-editor .tiptap .hljs-symbol, .notion-editor .tiptap .hljs-bullet {
  color: #a6e3a1;
}
.notion-editor .tiptap .hljs-title, .notion-editor .tiptap .hljs-section {
  color: #89b4fa;
}
.notion-editor .tiptap .hljs-keyword, .notion-editor .tiptap .hljs-selector-tag {
  color: #cba6f7;
}
.notion-editor .tiptap .hljs-emphasis {
  font-style: italic;
}
.notion-editor .tiptap .hljs-strong {
  font-weight: 700;
}

/* ─── Block Handle (Angular-managed) ─── */
.block-handle-angular {
  position: absolute;
  left: 4px;
  display: flex;
  align-items: center;
  gap: 2px;
  z-index: 40;
}
.block-handle-angular .block-handle-add,
.block-handle-angular .block-handle-drag {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border: none;
  background: none;
  border-radius: 4px;
  cursor: pointer;
  color: #9ca3af;
  transition: color 0.1s, background 0.1s;
}
.block-handle-angular .block-handle-add:hover,
.block-handle-angular .block-handle-drag:hover {
  color: #374151;
  background: #f3f4f6;
}
.block-handle-angular .block-handle-drag {
  cursor: grab;
}
.block-handle-angular .block-handle-drag:active {
  cursor: grabbing;
}

/* ─── Slash Menu ─── */
.slash-menu {
  position: absolute;
  z-index: 50;
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.12);
  max-height: 360px;
  width: 280px;
  overflow-y: auto;
}
.slash-menu::-webkit-scrollbar {
  width: 4px;
}
.slash-menu::-webkit-scrollbar-track {
  background: transparent;
}
.slash-menu::-webkit-scrollbar-thumb {
  background: #d1d5db;
  border-radius: 4px;
}
.slash-menu .slash-menu-inner {
  padding: 6px;
}
.slash-menu .slash-menu-category {
  font-size: 11px;
  font-weight: 600;
  color: #9ca3af;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding: 8px 10px 4px;
}
.slash-menu .slash-menu-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 10px;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.1s;
}
.slash-menu .slash-menu-item:hover, .slash-menu .slash-menu-item.active {
  background: #f3f4f6;
}
.slash-menu .slash-menu-item .slash-menu-icon {
  font-size: 18px;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f9fafb;
  border-radius: 6px;
  border: 1px solid #e5e7eb;
  flex-shrink: 0;
}
.slash-menu .slash-menu-item .slash-menu-text {
  flex: 1;
  min-width: 0;
}
.slash-menu .slash-menu-item .slash-menu-text .slash-menu-title {
  font-size: 13px;
  font-weight: 500;
  color: #1f2937;
}
.slash-menu .slash-menu-item .slash-menu-text .slash-menu-desc {
  font-size: 11px;
  color: #9ca3af;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* ─── Bubble Menu ─── */
.bubble-menu {
  position: absolute;
  z-index: 50;
  display: flex;
  align-items: center;
  gap: 1px;
  padding: 4px 6px;
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  transform: translateX(-50%);
  white-space: nowrap;
}
.bubble-menu .bubble-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 28px;
  height: 28px;
  border: none;
  background: none;
  border-radius: 4px;
  cursor: pointer;
  color: #4b5563;
  font-size: 12px;
  position: relative;
  transition: background 0.1s, color 0.1s;
  padding: 0 4px;
}
.bubble-menu .bubble-btn:hover {
  background: #f3f4f6;
  color: #1f2937;
}
.bubble-menu .bubble-btn.is-active {
  background: #eff6ff;
  color: #2563eb;
}
.bubble-menu .bubble-btn .color-indicator {
  position: absolute;
  bottom: 2px;
  left: 50%;
  transform: translateX(-50%);
  width: 14px;
  height: 3px;
  border-radius: 1px;
}
.bubble-menu .bubble-btn-text {
  display: flex;
  align-items: center;
  gap: 2px;
  padding: 0 6px;
  white-space: nowrap;
}
.bubble-menu .bubble-sep {
  display: block;
  width: 1px;
  height: 18px;
  background: #e5e7eb;
  margin: 0 3px;
  flex-shrink: 0;
}

/* ─── Turn Into Dropdown ─── */
.bubble-turninto-wrap {
  position: relative;
}

.turn-into-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  margin-top: 4px;
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  padding: 6px;
  z-index: 60;
  width: 180px;
}
.turn-into-dropdown .turn-into-label {
  font-size: 11px;
  font-weight: 600;
  color: #9ca3af;
  padding: 4px 8px 6px;
}
.turn-into-dropdown .turn-into-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 8px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 13px;
  transition: background 0.1s;
}
.turn-into-dropdown .turn-into-item:hover {
  background: #f3f4f6;
}
.turn-into-dropdown .turn-into-item .turn-into-icon {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f9fafb;
  border-radius: 4px;
  border: 1px solid #e5e7eb;
  font-size: 12px;
  flex-shrink: 0;
}
.turn-into-dropdown .turn-into-item .turn-into-title {
  color: #374151;
  font-weight: 500;
}

/* ─── Color Picker Dropdown ─── */
.bubble-color-wrap {
  position: relative;
}

.color-picker-dropdown {
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  margin-top: 4px;
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  padding: 10px;
  z-index: 60;
  width: 220px;
}
.color-picker-dropdown .color-picker-label {
  font-size: 11px;
  font-weight: 600;
  color: #6b7280;
  margin-bottom: 8px;
}
.color-picker-dropdown .color-picker-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}
.color-picker-dropdown .color-swatch {
  width: 24px;
  height: 24px;
  border-radius: 4px;
  border: 1px solid #e5e7eb;
  cursor: pointer;
  transition: transform 0.1s, box-shadow 0.1s;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}
.color-picker-dropdown .color-swatch:hover {
  transform: scale(1.2);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
  z-index: 1;
}
.color-picker-dropdown .color-swatch-reset {
  background: #fff !important;
  color: #9ca3af;
  font-size: 12px;
}

/* ─── Link Input Dropdown ─── */
.link-input-dropdown {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 4px;
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  padding: 6px;
  z-index: 60;
  width: 280px;
}
.link-input-dropdown .link-input-row {
  display: flex;
  align-items: center;
  gap: 4px;
}
.link-input-dropdown .link-input-field {
  flex: 1;
  height: 32px;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  padding: 0 10px;
  font-size: 13px;
  outline: none;
  color: #1f2937;
}
.link-input-dropdown .link-input-field:focus {
  border-color: #2563eb;
  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.15);
}
.link-input-dropdown .link-input-apply,
.link-input-dropdown .link-input-remove {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  background: white;
  cursor: pointer;
  color: #4b5563;
  font-size: 12px;
  flex-shrink: 0;
  transition: background 0.1s, color 0.1s;
}
.link-input-dropdown .link-input-apply:hover,
.link-input-dropdown .link-input-remove:hover {
  background: #f3f4f6;
}
.link-input-dropdown .link-input-apply {
  color: #16a34a;
}
.link-input-dropdown .link-input-apply:hover {
  background: #f0fdf4;
}
.link-input-dropdown .link-input-remove {
  color: #dc2626;
}
.link-input-dropdown .link-input-remove:hover {
  background: #fef2f2;
}

/* ─── Table Toolbar ─── */
.table-toolbar {
  position: absolute;
  z-index: 50;
  display: flex;
  align-items: center;
  gap: 2px;
  padding: 4px 6px;
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  white-space: nowrap;
}
.table-toolbar .table-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: none;
  background: none;
  border-radius: 4px;
  cursor: pointer;
  color: #4b5563;
  font-size: 12px;
  transition: background 0.1s;
}
.table-toolbar .table-btn:hover {
  background: #f3f4f6;
}
.table-toolbar .table-btn.text-red-500 {
  color: #ef4444;
}
.table-toolbar .table-btn.text-red-500:hover {
  background: #fef2f2;
}`],
})
export class PortalLpsysadminWidgetNotionEditorComponent implements OnInit, OnDestroy, OnChanges {
    @ViewChild('editorContainer') editorContainer: ElementRef;

    @Input() content: any = null;
    @Input() editable: boolean = true;
    @Input() placeholder: string = '';

    @Output() contentChange = new EventEmitter<any>();

    public editor: Editor | null = null;

    // Fixed toolbar state
    public toolbarVisible = false;
    public toolbarColorPickerOpen = false;
    public toolbarColorPickerMode: 'text' | 'bg' = 'text';
    public toolbarHeadingOpen = false;
    public toolbarInsertOpen = false;

    // Slash command menu state
    public slashMenuOpen = false;
    public slashMenuItems: SlashMenuItem[] = [];
    public slashFilteredItems: SlashMenuItem[] = [];
    public slashQuery = '';
    public slashMenuPos = { top: 0, left: 0 };
    public slashSelectedIndex = 0;
    private slashRange: any = null;

    // Bubble menu state
    public bubbleMenuOpen = false;
    public bubbleMenuPos = { top: 0, left: 0 };

    // Color picker state
    public colorPickerOpen = false;
    public colorPickerMode: 'text' | 'bg' = 'text';
    public textColors = TEXT_COLORS;
    public bgColors = BG_COLORS;

    // Table toolbar state
    public tableMenuOpen = false;
    public tableMenuPos = { top: 0, left: 0 };

    // Block menu state (turn-into in bubble menu)
    public blockMenuOpen = false;
    public blockMenuMode: 'add' | 'turninto' = 'add';
    public turnIntoItems: TurnIntoItem[] = TURN_INTO_ITEMS;

    // Block handle state (Angular-managed)
    public blockHandleVisible = false;
    public blockHandleTop = 0;
    public blockHandleHovered = false;
    private hoveredBlockPos: number | null = null;

    // Link input state
    public linkInputOpen = false;
    public linkInputUrl = '';

    // Table grid picker state
    public tableGridPickerOpen = false;
    public tableGridHoverRow = 0;
    public tableGridHoverCol = 0;
    public gridSizes = [1, 2, 3, 4, 5, 6];

    // Image paste handler reference
    private imagePasteHandler: ((e: Event) => void) | null = null;

    constructor(@Inject( Service) public service: Service,@Inject( ChangeDetectorRef)  private cdr: ChangeDetectorRef) { }

    public async ngOnInit() {
        await this.service.init();
        this.slashMenuItems = SLASH_MENU_ITEMS;
        this.slashFilteredItems = [...this.slashMenuItems];
        setTimeout(() => this.initEditor(), 0);
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['content'] && this.editor && !changes['content'].firstChange) {
            const current = this.editor.getJSON();
            if (JSON.stringify(current) !== JSON.stringify(this.content)) {
                this.editor.commands.setContent(this.content);
            }
        }
        if (changes['editable'] && this.editor && !changes['editable'].firstChange) {
            this.editor.setEditable(this.editable);
        }
    }

    ngOnDestroy() {
        this.destroyEditor();
        document.removeEventListener('click', this.closeMenusHandler);
    }

    private closeMenusHandler = (e: Event) => {
        let changed = false;
        if (this.colorPickerOpen) {
            this.colorPickerOpen = false;
            changed = true;
        }
        if (this.blockMenuOpen) {
            const target = e.target as HTMLElement;
            if (!target.closest('.turn-into-dropdown') && !target.closest('.bubble-turninto-wrap')) {
                this.blockMenuOpen = false;
                changed = true;
            }
        }
        if (this.linkInputOpen) {
            const target = e.target as HTMLElement;
            if (!target.closest('.link-input-wrap')) {
                this.linkInputOpen = false;
                changed = true;
            }
        }
        // Close toolbar dropdowns
        if (this.toolbarColorPickerOpen || this.toolbarHeadingOpen || this.toolbarInsertOpen) {
            const target = e.target as HTMLElement;
            if (!target.closest('.toolbar-dropdown-wrap')) {
                this.toolbarColorPickerOpen = false;
                this.toolbarHeadingOpen = false;
                this.toolbarInsertOpen = false;
                changed = true;
            }
        }
        if (this.tableGridPickerOpen) {
            const target = e.target as HTMLElement;
            if (!target.closest('.table-grid-dropdown') && !target.closest('.toolbar-dropdown-wrap')) {
                this.tableGridPickerOpen = false;
                changed = true;
            }
        }
        if (changed) this.cdr.detectChanges();
    };

    private destroyEditor() {
        if (this.imagePasteHandler && this.editor) {
            this.editor.view.dom.removeEventListener('paste', this.imagePasteHandler, true);
            this.imagePasteHandler = null;
        }
        if (this.editor) {
            this.editor.destroy();
            this.editor = null;
        }
    }

    private initEditor() {
        const el = this.editorContainer?.nativeElement;
        if (!el) return;
        this.destroyEditor();

        const placeholderText = this.placeholder || (this.editable
            ? "'/' 를 입력하면 명령어를 사용할 수 있습니다."
            : '');

        const uploadImageFn = async (file: File): Promise<string | null> => {
            try {
                const fd = new FormData();
                fd.append('upload', file);
                const res: any = await this.service.file.upload('/file/upload', fd, () => { });
                return res?.url || null;
            } catch (e) {
                console.error('[notion-editor] Image upload failed:', e);
                return null;
            }
        };

        this.editor = createNotionEditor({
            element: el,
            content: this.content,
            editable: this.editable,
            placeholder: placeholderText,
            uploadImageFn: this.editable ? uploadImageFn : undefined,
            onUpdate: (json: any) => {
                this.contentChange.emit(json);
            },
            onCreate: (_editor: Editor) => { },
        });

        if (this.editable) {
            this.editor.on('update', () => {
                this.handleSlashDetection();
                this.checkTableContext();
            });
            this.editor.on('selectionUpdate', () => {
                this.handleBubbleMenu();
                this.checkTableContext();
            });
            this.editor.on('focus', () => {
                this.toolbarVisible = true;
                this.cdr.detectChanges();
            });
            this.editor.on('blur', ({ event }) => {
                // Don't hide if clicking on toolbar
                const related = event?.relatedTarget as HTMLElement;
                if (related?.closest('.editor-fixed-toolbar')) return;
                setTimeout(() => {
                    if (!this.editor?.isFocused) {
                        this.toolbarVisible = false;
                        this.toolbarColorPickerOpen = false;
                        this.toolbarHeadingOpen = false;
                        this.toolbarInsertOpen = false;
                        this.tableGridPickerOpen = false;
                        this.cdr.detectChanges();
                    }
                }, 150);
            });
            el.addEventListener('keydown', (e: KeyboardEvent) => this.handleSlashKeydown(e));
            document.addEventListener('click', this.closeMenusHandler);

            // Capture-phase paste handler for reliable Ctrl+V image paste
            this.imagePasteHandler = (e: Event) => {
                const ce = e as ClipboardEvent;
                if (!ce.clipboardData) return;

                // Check items first
                const items = ce.clipboardData.items;
                if (items) {
                    for (let i = 0; i < items.length; i++) {
                        if (items[i].type.startsWith('image/')) {
                            const file = items[i].getAsFile();
                            if (file) {
                                e.preventDefault();
                                e.stopImmediatePropagation();
                                this.pasteImageFile(file);
                                return;
                            }
                        }
                    }
                }

                // Fallback: check files collection (some browsers/OS put screenshots here)
                const files = ce.clipboardData.files;
                if (files && files.length > 0) {
                    for (let i = 0; i < files.length; i++) {
                        if (files[i].type.startsWith('image/')) {
                            e.preventDefault();
                            e.stopImmediatePropagation();
                            this.pasteImageFile(files[i]);
                            return;
                        }
                    }
                }
            };
            this.editor.view.dom.addEventListener('paste', this.imagePasteHandler, true);
        }
    }

    /* ────────────────────────────────────────
       Image Paste (Ctrl+V)
       ──────────────────────────────────────── */
    private async pasteImageFile(file: File) {
        if (!this.editor) return;
        try {
            const fd = new FormData();
            fd.append('upload', file);
            const res: any = await this.service.file.upload('/file/upload', fd, () => { });
            const url = res?.url;
            if (url && this.editor) {
                this.editor.chain().focus().setImage({ src: url }).run();
            }
        } catch (e) {
            console.error('[notion-editor] Image paste upload failed:', e);
        }
    }

    /* ────────────────────────────────────────
       Fixed Toolbar Actions
       ──────────────────────────────────────── */
    public toggleToolbarHeading(event: Event) {
        event.stopPropagation();
        this.toolbarHeadingOpen = !this.toolbarHeadingOpen;
        this.toolbarInsertOpen = false;
        this.toolbarColorPickerOpen = false;
        this.tableGridPickerOpen = false;
        this.cdr.detectChanges();
    }

    public toggleToolbarInsert(event: Event) {
        event.stopPropagation();
        this.toolbarInsertOpen = !this.toolbarInsertOpen;
        this.toolbarHeadingOpen = false;
        this.toolbarColorPickerOpen = false;
        this.tableGridPickerOpen = false;
        this.cdr.detectChanges();
    }

    public toggleToolbarColorPicker(event: Event, mode: 'text' | 'bg') {
        event.stopPropagation();
        if (this.toolbarColorPickerOpen && this.toolbarColorPickerMode === mode) {
            this.toolbarColorPickerOpen = false;
        } else {
            this.toolbarColorPickerMode = mode;
            this.toolbarColorPickerOpen = true;
        }
        this.toolbarHeadingOpen = false;
        this.toolbarInsertOpen = false;
        this.tableGridPickerOpen = false;
        this.cdr.detectChanges();
    }

    public toolbarSetHeading(level: number) {
        this.editor?.chain().focus().toggleHeading({ level: level as 1 | 2 | 3 }).run();
        this.toolbarHeadingOpen = false;
        this.cdr.detectChanges();
    }

    public toolbarSetParagraph() {
        this.editor?.chain().focus().setParagraph().run();
        this.toolbarHeadingOpen = false;
        this.cdr.detectChanges();
    }

    public openTableGridPicker() {
        this.toolbarInsertOpen = false;
        this.tableGridPickerOpen = true;
        this.tableGridHoverRow = 0;
        this.tableGridHoverCol = 0;
        this.cdr.detectChanges();
    }

    public insertTableFromGrid(rows: number, cols: number) {
        this.editor?.chain().focus().insertTable({ rows, cols, withHeaderRow: true }).run();
        this.tableGridPickerOpen = false;
        this.cdr.detectChanges();
    }

    public toolbarInsertHR() {
        this.editor?.chain().focus().setHorizontalRule().run();
        this.toolbarInsertOpen = false;
        this.cdr.detectChanges();
    }

    public toolbarInsertCodeBlock() {
        this.editor?.chain().focus().toggleCodeBlock().run();
        this.toolbarInsertOpen = false;
        this.cdr.detectChanges();
    }

    public toolbarInsertBlockquote() {
        this.editor?.chain().focus().toggleBlockquote().run();
        this.toolbarInsertOpen = false;
        this.cdr.detectChanges();
    }

    public toolbarInsertBulletList() {
        this.editor?.chain().focus().toggleBulletList().run();
        this.toolbarInsertOpen = false;
        this.cdr.detectChanges();
    }

    public toolbarInsertOrderedList() {
        this.editor?.chain().focus().toggleOrderedList().run();
        this.toolbarInsertOpen = false;
        this.cdr.detectChanges();
    }

    public toolbarInsertTaskList() {
        this.editor?.chain().focus().toggleTaskList().run();
        this.toolbarInsertOpen = false;
        this.cdr.detectChanges();
    }

    public toolbarSetTextColor(color: string | null) {
        if (!this.editor) return;
        if (color) {
            this.editor.chain().focus().setColor(color).run();
        } else {
            this.editor.chain().focus().unsetColor().run();
        }
        this.toolbarColorPickerOpen = false;
        this.cdr.detectChanges();
    }

    public toolbarSetBgColor(color: string | null) {
        if (!this.editor) return;
        if (color) {
            this.editor.chain().focus().toggleHighlight({ color }).run();
        } else {
            this.editor.chain().focus().unsetHighlight().run();
        }
        this.toolbarColorPickerOpen = false;
        this.cdr.detectChanges();
    }

    /* ────────────────────────────────────────
       Block Handle (Angular-managed)
       ──────────────────────────────────────── */
    public onEditorMouseMove(event: MouseEvent) {
        if (!this.editor || !this.editable) return;
        const view = this.editor.view;
        const editorRect = view.dom.getBoundingClientRect();
        const pos = view.posAtCoords({ left: editorRect.left + 10, top: event.clientY });
        if (!pos) {
            if (!this.blockHandleHovered) this.blockHandleVisible = false;
            return;
        }
        const resolvedPos = view.state.doc.resolve(pos.pos);
        if (resolvedPos.depth < 1) {
            if (!this.blockHandleHovered) this.blockHandleVisible = false;
            return;
        }
        const blockPos = resolvedPos.before(resolvedPos.depth);
        const domNode = view.nodeDOM(blockPos);
        if (!domNode || !(domNode instanceof HTMLElement)) {
            if (!this.blockHandleHovered) this.blockHandleVisible = false;
            return;
        }
        const nodeRect = domNode.getBoundingClientRect();
        const wrapperEl = this.editorContainer.nativeElement.closest('.notion-editor-wrapper');
        if (!wrapperEl) return;
        const wrapperRect = wrapperEl.getBoundingClientRect();
        this.hoveredBlockPos = blockPos;
        this.blockHandleTop = nodeRect.top - wrapperRect.top + 2;
        this.blockHandleVisible = true;
        this.cdr.detectChanges();
    }

    public onEditorMouseLeave() {
        if (!this.blockHandleHovered) {
            this.blockHandleVisible = false;
            this.cdr.detectChanges();
        }
    }

    public hideBlockHandle() {
        setTimeout(() => {
            if (!this.blockHandleHovered) {
                this.blockHandleVisible = false;
                this.cdr.detectChanges();
            }
        }, 100);
    }

    public handleAddBlockClick() {
        if (!this.editor || this.hoveredBlockPos === null) return;
        const resolvedPos = this.editor.state.doc.resolve(this.hoveredBlockPos);
        const nodeEnd = resolvedPos.end(resolvedPos.depth);
        this.editor.chain()
            .focus()
            .setTextSelection(nodeEnd)
            .splitBlock()
            .insertContent('/')
            .run();
        this.blockHandleVisible = false;
        this.cdr.detectChanges();
    }

    public selectTurnIntoItem(item: TurnIntoItem) {
        if (!this.editor) return;
        item.command(this.editor);
        this.blockMenuOpen = false;
        this.cdr.detectChanges();
    }

    public switchBlockMenuMode(mode: 'add' | 'turninto') {
        this.blockMenuMode = mode;
        this.cdr.detectChanges();
    }

    /* ────────────────────────────────────────
       Slash Command Menu
       ──────────────────────────────────────── */
    private handleSlashDetection() {
        if (!this.editor || !this.editable) return;
        const { state } = this.editor;
        const { $from } = state.selection;
        const textBefore = $from.parent.textContent.slice(0, $from.parentOffset);

        const slashMatch = textBefore.match(/\/([^\s]*)$/);
        if (slashMatch) {
            this.slashQuery = slashMatch[1];
            this.slashRange = {
                from: $from.pos - slashMatch[0].length,
                to: $from.pos,
            };
            this.filterSlashItems();
            this.updateSlashMenuPosition();
            this.slashMenuOpen = true;
            this.slashSelectedIndex = 0;
        } else {
            this.slashMenuOpen = false;
        }
        this.cdr.detectChanges();
    }

    private filterSlashItems() {
        const q = this.slashQuery.toLowerCase();
        this.slashFilteredItems = q
            ? this.slashMenuItems.filter(item =>
                item.title.toLowerCase().includes(q) ||
                item.description.toLowerCase().includes(q) ||
                (item.keywords && item.keywords.some(k => k.toLowerCase().includes(q))))
            : [...this.slashMenuItems];
    }

    private updateSlashMenuPosition() {
        if (!this.editor) return;
        const { view } = this.editor;
        const { from } = view.state.selection;
        const coords = view.coordsAtPos(from);
        const containerRect = this.editorContainer.nativeElement.getBoundingClientRect();
        this.slashMenuPos = {
            top: coords.bottom - containerRect.top + 4,
            left: coords.left - containerRect.left,
        };
    }

    private handleSlashKeydown(e: KeyboardEvent) {
        if (!this.slashMenuOpen) return;
        if (e.key === 'ArrowDown') {
            e.preventDefault();
            this.slashSelectedIndex = (this.slashSelectedIndex + 1) % this.slashFilteredItems.length;
            this.scrollSlashItemIntoView();
            this.cdr.detectChanges();
        } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            this.slashSelectedIndex = (this.slashSelectedIndex - 1 + this.slashFilteredItems.length) % this.slashFilteredItems.length;
            this.scrollSlashItemIntoView();
            this.cdr.detectChanges();
        } else if (e.key === 'Enter') {
            e.preventDefault();
            if (this.slashFilteredItems.length > 0) {
                this.selectSlashItem(this.slashFilteredItems[this.slashSelectedIndex]);
            }
        } else if (e.key === 'Escape') {
            this.slashMenuOpen = false;
            this.cdr.detectChanges();
        }
    }

    private scrollSlashItemIntoView() {
        setTimeout(() => {
            const el = document.querySelector('.slash-menu-item.active');
            if (el) el.scrollIntoView({ block: 'nearest' });
        }, 0);
    }

    public selectSlashItem(item: SlashMenuItem) {
        if (!this.editor || !this.slashRange) return;
        this.editor.chain().focus().deleteRange(this.slashRange).run();
        if (item.title === '이미지') {
            this.uploadImage();
        } else if (item.title === '파일') {
            this.uploadFile();
        } else {
            item.command(this.editor);
        }
        this.slashMenuOpen = false;
        this.cdr.detectChanges();
    }

    /* ────────────────────────────────────────
       Bubble Menu (Text Selection Toolbar)
       ──────────────────────────────────────── */
    private handleBubbleMenu() {
        if (!this.editor || !this.editable) return;
        const { from, to, empty } = this.editor.state.selection;
        if (empty || from === to) {
            this.bubbleMenuOpen = false;
            this.colorPickerOpen = false;
            this.linkInputOpen = false;
            this.cdr.detectChanges();
            return;
        }
        const { view } = this.editor;
        const coords = view.coordsAtPos(from);
        const endCoords = view.coordsAtPos(to);
        const containerRect = this.editorContainer.nativeElement.getBoundingClientRect();
        this.bubbleMenuPos = {
            top: coords.top - containerRect.top - 48,
            left: ((coords.left + endCoords.left) / 2) - containerRect.left,
        };
        this.bubbleMenuOpen = true;
        this.cdr.detectChanges();
    }

    /* ────────────────────────────────────────
       Color Picker
       ──────────────────────────────────────── */
    public toggleColorPicker(event: Event, mode: 'text' | 'bg') {
        event.stopPropagation();
        if (this.colorPickerOpen && this.colorPickerMode === mode) {
            this.colorPickerOpen = false;
        } else {
            this.colorPickerMode = mode;
            this.colorPickerOpen = true;
        }
        this.linkInputOpen = false;
        this.cdr.detectChanges();
    }

    public setTextColor(color: string | null) {
        if (!this.editor) return;
        if (color) {
            this.editor.chain().focus().setColor(color).run();
        } else {
            this.editor.chain().focus().unsetColor().run();
        }
        this.colorPickerOpen = false;
        this.cdr.detectChanges();
    }

    public setBgColor(color: string | null) {
        if (!this.editor) return;
        if (color) {
            this.editor.chain().focus().toggleHighlight({ color }).run();
        } else {
            this.editor.chain().focus().unsetHighlight().run();
        }
        this.colorPickerOpen = false;
        this.cdr.detectChanges();
    }

    /* ────────────────────────────────────────
       Table Context Toolbar
       ──────────────────────────────────────── */
    private checkTableContext() {
        if (!this.editor || !this.editable) return;
        const isInTable = this.editor.isActive('table');
        if (isInTable) {
            this.updateTableMenuPosition();
            this.tableMenuOpen = true;
            this.cdr.detectChanges();
        } else if (this.tableMenuOpen) {
            this.tableMenuOpen = false;
            this.cdr.detectChanges();
        }
    }

    private updateTableMenuPosition() {
        if (!this.editor) return;
        const { view, state } = this.editor;
        const { from } = state.selection;
        const containerRect = this.editorContainer.nativeElement.getBoundingClientRect();
        try {
            const domAtPos = view.domAtPos(from);
            let el: HTMLElement = domAtPos.node as HTMLElement;
            if (el.nodeType === Node.TEXT_NODE) el = el.parentElement!;
            const tableWrapper = el.closest('.tableWrapper') as HTMLElement;
            const target = tableWrapper || el.closest('table') as HTMLElement;
            if (target) {
                const targetRect = target.getBoundingClientRect();
                this.tableMenuPos = {
                    top: targetRect.top - containerRect.top - 44,
                    left: targetRect.left - containerRect.left,
                };
                return;
            }
        } catch (_) { }
        const coords = view.coordsAtPos(from);
        this.tableMenuPos = {
            top: coords.top - containerRect.top - 44,
            left: coords.left - containerRect.left,
        };
    }

    public addRowBefore() { this.editor?.chain().focus().addRowBefore().run(); }
    public addRowAfter() { this.editor?.chain().focus().addRowAfter().run(); }
    public deleteRow() { this.editor?.chain().focus().deleteRow().run(); }
    public addColumnBefore() { this.editor?.chain().focus().addColumnBefore().run(); }
    public addColumnAfter() { this.editor?.chain().focus().addColumnAfter().run(); }
    public deleteColumn() { this.editor?.chain().focus().deleteColumn().run(); }
    public deleteTable() { this.editor?.chain().focus().deleteTable().run(); }
    public toggleHeaderRow() { this.editor?.chain().focus().toggleHeaderRow().run(); }
    public mergeCells() { this.editor?.chain().focus().mergeCells().run(); }
    public splitCell() { this.editor?.chain().focus().splitCell().run(); }

    /* ────────────────────────────────────────
       Formatting Commands
       ──────────────────────────────────────── */
    public toggleBold() { this.editor?.chain().focus().toggleBold().run(); }
    public toggleItalic() { this.editor?.chain().focus().toggleItalic().run(); }
    public toggleUnderline() { this.editor?.chain().focus().toggleUnderline().run(); }
    public toggleStrike() { this.editor?.chain().focus().toggleStrike().run(); }
    public toggleCode() { this.editor?.chain().focus().toggleCode().run(); }
    public toggleHighlight() { this.editor?.chain().focus().toggleHighlight().run(); }

    public setTextAlign(align: string) {
        this.editor?.chain().focus().setTextAlign(align).run();
    }

    public setHeading(level: number) {
        this.editor?.chain().focus().toggleHeading({ level: level as 1 | 2 | 3 }).run();
    }

    public isActive(name: string, attrs?: any): boolean {
        return this.editor?.isActive(name, attrs) || false;
    }

    /* ────────────────────────────────────────
       Link
       ──────────────────────────────────────── */
    public openLinkInput(event: Event) {
        event.stopPropagation();
        this.colorPickerOpen = false;
        const prev = this.editor?.getAttributes('link').href;
        this.linkInputUrl = prev || 'https://';
        this.linkInputOpen = true;
        this.cdr.detectChanges();
        setTimeout(() => {
            const input = document.querySelector('.link-input-field') as HTMLInputElement;
            if (input) { input.focus(); input.select(); }
        }, 50);
    }

    public applyLink() {
        if (!this.editor) return;
        const url = this.linkInputUrl.trim();
        if (!url || url === 'https://') {
            this.editor.chain().focus().unsetLink().run();
        } else {
            this.editor.chain().focus().extendMarkRange('link').setLink({ href: url }).run();
        }
        this.linkInputOpen = false;
        this.cdr.detectChanges();
    }

    public removeLink() {
        if (!this.editor) return;
        this.editor.chain().focus().unsetLink().run();
        this.linkInputOpen = false;
        this.cdr.detectChanges();
    }

    public handleLinkKeydown(e: KeyboardEvent) {
        if (e.key === 'Enter') {
            e.preventDefault();
            this.applyLink();
        } else if (e.key === 'Escape') {
            this.linkInputOpen = false;
            this.cdr.detectChanges();
        }
    }

    /* ────────────────────────────────────────
       Image / File Upload
       ──────────────────────────────────────── */
    public async uploadImage() {
        const files = await this.service.file.select({ accept: 'image/*' });
        if (!files || files.length === 0) return;
        await this.service.loading.show();
        for (const file of files) {
            const fd = new FormData();
            fd.append('upload', file);
            try {
                const res: any = await this.service.file.upload('/file/upload', fd, () => { });
                const url = res?.url;
                if (url && this.editor) {
                    this.editor.chain().focus().setImage({ src: url }).run();
                }
            } catch (e) {
                console.error('[notion-editor] Image upload failed:', e);
            }
        }
        await this.service.loading.hide();
    }

    public async uploadFile() {
        const files = await this.service.file.select();
        if (!files || files.length === 0) return;
        await this.service.loading.show();
        for (const file of files) {
            const fd = new FormData();
            fd.append('upload', file);
            try {
                const res: any = await this.service.file.upload('/file/upload', fd, () => { });
                const url = res?.url;
                if (url && this.editor) {
                    this.editor.chain().focus().insertContent({
                        type: 'fileAttachment',
                        attrs: { url, name: file.name, size: file.size },
                    }).run();
                }
            } catch (e) {
                console.error('[notion-editor] File upload failed:', e);
            }
        }
        await this.service.loading.hide();
    }

    /* ────────────────────────────────────────
       Helpers
       ──────────────────────────────────────── */
    public getSlashCategories(): string[] {
        const categories: string[] = [];
        for (const item of this.slashFilteredItems) {
            if (!categories.includes(item.category)) categories.push(item.category);
        }
        return categories;
    }

    public getItemsByCategory(category: string): SlashMenuItem[] {
        return this.slashFilteredItems.filter(item => item.category === category);
    }

    public getOverallIndex(item: SlashMenuItem): number {
        return this.slashFilteredItems.indexOf(item);
    }

    public getCurrentBlockType(): string {
        if (!this.editor) return '텍스트';
        if (this.editor.isActive('heading', { level: 1 })) return '제목 1';
        if (this.editor.isActive('heading', { level: 2 })) return '제목 2';
        if (this.editor.isActive('heading', { level: 3 })) return '제목 3';
        if (this.editor.isActive('bulletList')) return '글머리 기호';
        if (this.editor.isActive('orderedList')) return '번호 목록';
        if (this.editor.isActive('taskList')) return '할 일';
        if (this.editor.isActive('blockquote')) return '인용';
        if (this.editor.isActive('codeBlock')) return '코드';
        return '텍스트';
    }
}

export default PortalLpsysadminWidgetNotionEditorComponent;